export const IconBasketDelete: {
  name: 'icon_basket_delete-18de68547011'
} = {
  name: 'icon_basket_delete-18de68547011'
}
